import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import { countdownFrom } from './tokenCountdown';

import { InviteReview } from '../../../../types/responses/Interoperability';
import { PartnerLogo } from '../../../molecules/PartnerLogo';

const Banner = styled.div`
  background: #fff;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
`;

const Received = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  /*
    Um convite por linha. Sem separação entre elas, os botões "Revisar convite" da
    coluna da direita encostam uns nos outros e, com três convites ou mais, a lista
    vira um bloco só (MV2-1822). O respiro segue o das linhas de texto ao lado, que
    é a referência que o olho usa para ler a lista.
  */
  & + & {
    margin-top: 10px;
  }
`;

const Sent = styled.div`
  margin-top: 8px;
  color: #6b7280;
  font-size: 12px;
`;

const ReviewButton = styled.button`
  background: ${({ theme }) => theme.primary};
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  cursor: pointer;
`;

export type PendingInvitesBannerProps = {
  received: InviteReview[];
  sentCount: number;
  onReview: (invite: InviteReview) => void;
};

/**
 * Banner de convites pendentes (MV2-1712).
 *
 * Não renderiza nada quando não há convite algum: um banner vazio ocupando o
 * topo da tela só empurra o conteúdo para baixo sem informar nada.
 */
export const PendingInvitesBanner: React.FC<PendingInvitesBannerProps> = ({
  received,
  sentCount,
  onReview,
}) => {
  if (!received?.length && !sentCount) {
    return null;
  }

  return (
    <Banner>
      {received?.map((invite) => {
        const remaining = countdownFrom(invite.expires_at);

        return (
          <Received key={invite.invite_id}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <PartnerLogo
                name={invite.source_tenant_name || ''}
                alias={invite.source_tenant_alias}
              />
              <span>
              <strong>{invite.source_tenant_name}</strong>{' '}
              {invite.scope_station_count
                ? `${T('wants your app to display')} ${invite.scope_station_count} ${T('stations')}`
                : T('wants your app to display their stations')}
              {!remaining.expired && ` · ${T('expires in')} ${remaining.text}`}
              </span>
            </div>
            <ReviewButton type="button" onClick={() => onReview(invite)}>
              {T('Review invite')}
            </ReviewButton>
          </Received>
        );
      })}

      {sentCount > 0 && (
        <Sent>
          {sentCount} {T('invite(s) sent awaiting acceptance')}
        </Sent>
      )}
    </Banner>
  );
};
